<template id="carousel">
    <div id="relatedCourses">
          <p class="sectionTitle">{{title}}</p>
      <!--<p>total length:{{totalLength}}, moved length:{{movedLength}}, length remaining: {{lengthRemaining}}</p>-->
          <div class="carousel">
            <i class="fas fa-chevron-left" v-bind:class="{active: activePrev}" id="previous" v-on:click="prev_card"></i>
            <div id="courseCardWrapper" class="displayArea" ref="carousel">
              <CourseCardSquare
                v-if = "type ==='course'"
                v-for="item in this.cardList"
                :key="item.url_object_id"
                :id="item.url_object_id"
                :image="item.image_url"
                :title="item.name"
                :provider="item.provider"
                :platform="item.platform"
                :domain = "item.domain"
              ></CourseCardSquare>
            </div>
            <i class="fas fa-chevron-right" v-bind:class="{active: activeNext}" id="next" v-on:click="next_card"></i>
          </div>
        </div>
</template>

<script>
  import CourseCardSquare from './CourseCardSquare'

  export default {
      name: "Carousel.vue",
      components: {
        CourseCardSquare
      },
      props: {
        type: String, //type if carousel cards - can be instructors in the future
        title: String, //carousel's title
        cardList: Array, //list of related courses/instructors from db
      },
    data(){
        return {
          totalLength:2500,
          movedLength:0,
          lengthRemaining:2500,
          cardWidth:250
        }
      },
       methods:{
        next_card:function(event){
          if(event.target.classList.contains('active')){
              this.movedLength += this.cardWidth;
              this.lengthRemaining -= this.cardWidth;
              let i;
              for(i=0; i<this.cardList.length; i++){
                this.$refs.carousel.childNodes[i].style.transform = "translate(-"+this.movedLength+"px,0)";
              }

          }
        },
        prev_card:function(event){
          if(event.target.classList.contains('active')){
            this.movedLength -= this.cardWidth;
            this.lengthRemaining +=this.cardWidth;
            let i;
            for(i=0; i<this.cardList.length; i++){
              this.$refs.carousel.childNodes[i].style.transform = "translate(-"+this.movedLength+"px,0)";
            }
          }
        }
      },
      computed:{
        activePrev(){
          return this.movedLength >= this.cardWidth; //250*this.cardNumber = total width of cards displayed
        },
        activeNext(){
          return this.lengthRemaining > this.cardWidth; //determine if the next arrow needs to be active
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/view/General/Carousel.vue